import { motion } from "framer-motion";

const FOUNDER_IMG =
  "https://customer-assets.emergentagent.com/job_rb-coaching-hub-1/artifacts/qsuk6cvj_WhatsApp%20Image%202026-05-10%20at%201.06.35%20PM.jpeg";

const CREDENTIALS = [
  "Certified Life Coach",
  "Certified Yoga, Breathing, Mindfulness & Meditation",
  "Motivational Speaker · Seattle Area",
  "Master's in English Literature",
  "Master's in French",
  "Youth Empowerment & Advocacy",
  "Fluent: Dari, Pashto, Urdu, French, English",
];

export const About = () => {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative py-24 md:py-32 bg-white"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-20 items-start">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.9 }}
            className="lg:col-span-5 relative lg:sticky lg:top-28"
          >
            <div className="relative aspect-[4/5] w-full overflow-hidden">
              <img
                src={FOUNDER_IMG}
                alt="Reza Muhammad Behzad — Founder, RB InnerRise Coaching Academy"
                className="absolute inset-0 w-full h-full object-cover"
                style={{ objectPosition: "65% 40%" }}
              />
            </div>
            <div className="absolute -bottom-6 -right-6 hidden md:block bg-[#0B2B40] text-white p-6 max-w-[240px]">
              <div className="font-serif text-2xl leading-snug">
                Life Coach · Educator · Speaker
              </div>
              <div className="text-xs tracking-[0.2em] uppercase mt-3 text-white/70">
                Founder · RBICA
              </div>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.9, delay: 0.1 }}
            className="lg:col-span-7"
          >
            <div className="text-xs tracking-[0.3em] uppercase text-[#1D4E89] font-medium mb-5">
              Co-Founder · Speaking & Content
            </div>
            <h2
              data-testid="about-headline"
              className="font-serif text-4xl md:text-5xl text-[#0B2B40] tracking-tight leading-tight font-light"
            >
              Meet <span className="italic">Reza Muhammad Behzad</span> — founder of
              RBICA.
            </h2>

            <div className="mt-8 space-y-5 text-[#4A5568] text-lg leading-relaxed font-light">
              <p>
                Reza is a Certified Life Coach and motivational speaker serving
                the Seattle area. As a dedicated youth advocate with Master's
                degrees in English Literature and French, he works directly
                with young people navigating life transitions — bringing both
                academic rigor and lived wisdom to his approach to
                transformation and human potential.
              </p>
              <p>
                His expertise sits at the meeting point of narrative,
                storytelling, and the power of language to transform — a
                practice shaped by a multilingual life and decades of work in
                education, wellness and community.
              </p>
            </div>

            <div className="mt-12">
              <div className="text-xs tracking-[0.25em] uppercase text-[#1D4E89] font-medium mb-5">
                Credentials & Background
              </div>
              <ul className="grid sm:grid-cols-2 gap-y-3 gap-x-8">
                {CREDENTIALS.map((c) => (
                  <li
                    key={c}
                    className="flex items-start gap-3 text-[#1A202C] text-[15px]"
                    data-testid={`credential-${c.split(" ")[0].toLowerCase()}`}
                  >
                    <span className="mt-2 w-1.5 h-1.5 rounded-full bg-[#1D4E89] flex-shrink-0" />
                    <span>{c}</span>
                  </li>
                ))}
              </ul>
            </div>

            <div className="mt-12 border-l-2 border-[#1D4E89] pl-6 py-1">
              <p className="font-serif italic text-xl md:text-2xl text-[#0B2B40] leading-snug">
                “I believe every human being has the ability to grow, lead, and
                create a meaningful future through learning, wellness,
                confidence, and purpose.”
              </p>
              <div className="mt-4 text-xs tracking-[0.25em] uppercase text-[#4A5568]">
                — Reza Muhammad Behzad, Founder
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default About;
